import styled from "styled-components";

export const DemoIFrame = styled.iframe`
  height: calc(100vh - 125px);
  width: 100%;
  box-shadow: none;
  border: none;
`;
